import { render, staticRenderFns } from "./ServiceChargePayer.vue?vue&type=template&id=96501f56&"
import script from "./ServiceChargePayer.vue?vue&type=script&lang=js&"
export * from "./ServiceChargePayer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargePayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports